import axiosService from "../axios";

export const fetchChapters = () => {
    return axiosService.get(`${process.env.REACT_APP_API_URL}/chapters`);
};
